<template>
  <form class="serviceTypeForm" onsubmit="return false" @submit="send">
    <div class="row wrap justify-around column-s">
      <div class="column grid-2-g grid-12">
        <label>Especialidade</label>
        {{ form.update && form.nome_especialidade }}
        <select v-if="!form.update" v-model="form.id_especialidade" required>
          <option v-for="(esp, j) of especialities" :value="esp.id" :key="'esp' + j">
            {{ esp.nome }}
          </option>
        </select>
      </div>
      <div class="column grid-2-g grid-12">
        <label>Nome</label>
        <input v-model="form.nome" placeholder="Nome" required />
      </div>
      <div class="column grid-2-g grid-12">
        <label>Base de custo</label>
        <select v-model="form.id_base_custo" required>
          <option v-for="(base, j) of basisCost" :value="base.id" :key="'bc' + j">
            {{ base.nome }}
          </option>
        </select>
      </div>
      <div class="column grid-2-g grid-12">
        <label>Forma atendimento</label>
        <select v-model="form.forma_atendimento" required>
          <option value="presencial">Presencial</option>
          <option value="remoto">Remoto</option>
        </select>
      </div>
      <div class="column grid-2-g grid-12">
        <label>Tipo</label>
        <select v-model="form.tipo" required>
          <option value="atendimento">Atendimento avulso</option>
          <option value="alocacao">Alocação</option>
        </select>
      </div>
    </div>
    <div class="row wrap justify-around align-center">
      <div class="column grid-2-g grid-5">
        <label>Duração Atendimento</label>
        {{ form.update && form.duracao_atendimento }}
        <input v-if="!form.update" v-model="form.duracao_atendimento" v-mask="'##:##'" placeholder="HH:mm" required />
      </div>
      <div v-if="form.tipo == 'alocacao'" class="column grid-2-g grid-5">
        <label>Duração Folga</label>
        {{ form.update && form.duracao_folga }}
        <input v-if="!form.update" v-model="form.duracao_folga" v-mask="'##:##'" placeholder="Duração Folga" required />
      </div>
      <div v-if="form.tipo == 'alocacao'" class="column grid-2-g grid-5">
        <label>Duração Alocação</label>
        {{ form.update && form.duracao_alocacao }}
        <input v-if="!form.update" v-model="form.duracao_alocacao" placeholder="Duração Alocação" required />
      </div>
      <div class="column grid-2-g grid-5">
        <label>Tipo Deslocamento</label>
        <select v-model="form.tipo_deslocamento" @change="validaTipo()" required>
          <option value="variavel">Variável</option>
          <option value="fixo">Fixo</option>
          <option value="zero">Zero</option>
        </select>
      </div>
      <div class="column grid-2-g grid-5" v-if="form.tipo_deslocamento == 'fixo'">
        <label>Valor Deslocamento Fixo</label>
        <Money v-model="form.valor_deslocamento_fixo" v-bind="money" />
      </div>

      <div class="column grid-2-g grid-5" v-if="form.tipo_deslocamento == 'variavel'">
        <label>Limite KM Deslocamento Variável</label>
        <input type="number" v-model="form.limite_km_deslocamento_variavel" />
      </div>
      <div class="column grid-2-g grid-5" v-if="form.tipo_deslocamento == 'variavel'">
        <label>Valor Deslocamento Variável</label>
        <Money v-model="form.valor_deslocamento_variavel" v-bind="money" />
      </div>

      <div class="column grid-2-g grid-5">
        <label>Folga Obrigatória</label>
        <input v-model="form.folga_obrigatoria" v-mask="'##:##'" placeholder="Folga Obrigatória" required />
      </div>
      <div class="column grid-2-g grid-5">
        <label>Orientação</label>
        <SelectFilter v-if="guidelines.length" :list="guidelines" @value="(item) => (form.id_orientacao = item.id)"
          :name="['nome', 'nome_cliente']"
          :text="form.nome_orientacao && form.nome_orientacao + ' - ' + form.cliente_orientacao" />
      </div>
      <div class="column grid-1-g grid-5">
        <label>Interno</label>
        <Turnkey :data="turnkey" />
      </div>
      <div class="column grid-2-g grid-12">
        <label>Unidade Negócio</label>
        <select v-model="form.unidade_negocio" required>
          <option value="infraestrutura">Infraestrutura</option>
          <option value="device">Device</option>
          <option value="digital">Digital</option>
        </select>
      </div>
      <div class="column grid-2-g grid-5">
        <label>Proporção Custo Orçado (%)</label>
        <input class="input" v-model="proporcao_custo_orcado" readonly />
      </div>
      <div class="column grid-2-g grid-5">
        <label>Dedução Faturamento Job Improdutivo (0-100%)</label>
        <Money v-model="form.deducao_fat_job_improdutivo" v-bind="money" @change.native="({ target: { value } }) => {
          if (v == '-') return
          let v = parseFloat(value.replace('.', '').replace(',', '.')).toFixed(2);
          if (v > 100) v = 100
          if (v < 0) v = 0
          if (v == 0) v = '';
          form.change('deducao_fat_job_improdutivo', v);
          form.deducao_fat_job_improdutivo = v;
          $forceUpdate()
        }" />
      </div>
      <div class="column grid-2-g grid-5">
        <label>Dedução Custo Job Improdutivo (0-100%)</label>
        <Money v-model="form.deducao_job_improdutivo" v-bind="money" @change.native="({ target: { value } }) => {
          let v = parseFloat(value.replace('.', '').replace(',', '.')).toFixed(2);
          if (v > 100) v = 100;
          if (v < 0) v = 0;
          if (v == 0) v = '';
          form.change('deducao_job_improdutivo', v);
          form.deducao_job_improdutivo = v;
          $forceUpdate()
        }" />
      </div>
      <div class="column grid-6-g grid-12">
        <label>Negócio</label>
        <select v-model="form.id_negocio">
          <option value="">SELECIONE</option>
          <option v-for="n in negocios" :value="n.id" :key="n.id">{{ n.fechado_em | date }} -
            {{ n.vendedor }} - {{ n.cliente }} - {{ n.titulo }}
          </option>
        </select>
      </div>
    </div>
    <div class="section column align-center">CUSTOS<br>
      <Turnkey
        :data="{ show: true, on: acusto, toggle: () => { acusto = !acusto; if (!acusto) custo = { job: '', hora: '', j: '', h: '' } } }" />
      <br><span>SIMPLIFICADO</span>
    </div>
    <div v-if="acusto" class="row wrap justify-around" style="margin-top:20px">
      <div class="bk column grid-2-g grid-3-m">
        <label>Valor do Job</label>
        <Money id="cj" v-model="custo.job" v-bind="money"
          @change.native="({ target: { value } }) => custo.j = parseFloat(parseFloat(value.toString().replace('.', '').replace(',', '.')) * (proporcao_custo_orcado / 100)).toFixed(2)" />
        <div class="inf">Interno<br><b>R$ {{ custo.j | money }}</b></div>
      </div>
      <div class="bk column grid-2-g grid-3-m">
        <label>Valor Hora Extra</label>
        <Money id="ch" v-model="custo.hora" v-bind="money"
          @change.native="({ target: { value } }) => custo.h = parseFloat(parseFloat(value.toString().replace('.', '').replace(',', '.')) * (proporcao_custo_orcado / 100)).toFixed(2)"
          required />
        <div class="inf">Interno<br><b>R$ {{ custo.h | money }}</b></div>
      </div>
    </div>
    <div v-else class="row wrap justify-around" style="margin-top:20px">
      <div class="bk column grid-2-g grid-3-m">
        <label>Valor do Job</label>
        <Money v-model="form.valor_orcado_job_interior" v-bind="money"
          @change.native="({ target: { value } }) => calc('valor_job_interior', value)" />
        <div class="inf">Interno<br><b>R$ {{ form.valor_job_interior | money }}</b></div>
        <label>Valor do Job FHC</label>
        <Money v-model="form.valor_orcado_job_interior_diferenciado" v-bind="money"
          @change.native="({ target: { value } }) => calc('valor_job_interior_diferenciado', value)" required />
        <div class="inf">Interno<br><b>R$ {{ form.valor_job_interior_diferenciado | money }}</b></div>
      </div>
      <div class="bk column grid-2-g grid-3-m grid-6-s">
        <label>Valor Hora Extra</label>
        <Money v-model="form.valor_orcado_extra_interior" v-bind="money"
          @change.native="({ target: { value } }) => calc('valor_extra_interior', value)" required />
        <div class="inf">Interno<br><b>R$ {{ form.valor_extra_interior | money }}</b></div>
        <label>Valor Hora Extra FHC</label>
        <Money v-model="form.valor_orcado_extra_interior_diferenciado" v-bind="money"
          @change.native="({ target: { value } }) => calc('valor_extra_interior_diferenciado', value)" />
        <div class="inf">Interno<br><b>R$ {{ form.valor_extra_interior_diferenciado | money }}</b></div>
      </div>
      <div class="bk column grid-2-g grid-3-m grid-6-s">
        <label>Valor do Job Capital</label>
        <Money v-model="form.valor_orcado_job_capital" v-bind="money"
          @change.native="({ target: { value } }) => calc('valor_job_capital', value)" />
        <div class="inf">Interno<br><b>R$ {{ form.valor_job_capital | money }}</b></div>
        <label>Valor do Job Capital FHC</label>
        <Money v-model="form.valor_orcado_job_capital_diferenciado" v-bind="money"
          @change.native="({ target: { value } }) => calc('valor_job_capital_diferenciado', value)" />
        <div class="inf">Interno<br><b>R$ {{ form.valor_job_capital_diferenciado | money }}</b></div>
      </div>
      <div class="bk column grid-2-g grid-3-m grid-6-s">
        <label>Valor Hora Extra Capital</label>
        <Money v-model="form.valor_orcado_extra_capital" v-bind="money"
          @change.native="({ target: { value } }) => calc('valor_extra_capital', value)" />
        <div class="inf">Interno<br><b>R$ {{ form.valor_extra_capital | money }}</b></div>
        <label>Valor Hora Extra Capital FHC</label>
        <Money v-model="form.valor_orcado_extra_capital_diferenciado" v-bind="money"
          @change.native="({ target: { value } }) => calc('valor_extra_capital_diferenciado', value)" />
        <div class="inf">Interno<br><b>R$ {{ form.valor_extra_capital_diferenciado | money }}</b></div>
      </div>
    </div>
    <div class="legenda" v-if="!acusto"><b>(FHC)</b> Fora do horário comercial</div>

    <div class="section column align-center">FATURAMENTO<br>
      <Turnkey
        :data="{ show: true, on: afat, toggle: () => { afat = !afat; if (!afat) fat = { job: '', hora: '' } } }" />
      <br><span>SIMPLIFICADO</span>
    </div>
    <div v-if="afat" class="row wrap justify-around" style="margin-top:20px">
      <div class="bk column grid-2-g grid-3-m">
        <label>Valor faturamento do job</label>
        <Money id="fj" v-model="fat.job" v-bind="money" />

      </div>
      <div class="bk column grid-2-g grid-3-m">
        <label>Hora extra faturamento</label>
        <Money id="fh" v-model="fat.hora" v-bind="money" />

      </div>
    </div>
    <div v-else class="row wrap justify-around align-center" style="margin-top:20px">
      <div class="bk column grid-2-g grid-3-m grid-6-s">
        <label>Valor faturamento do job</label>
        <Money v-model="form.valor_fat_job_interior" v-bind="money" />
        <label>Valor do faturamento job FHC</label>
        <Money v-model="form.valor_fat_job_interior_diferenciado" v-bind="money" required />
      </div>
      <div class="bk column grid-2-g grid-3-m grid-6-s">
        <label>Hora extra faturamento</label>
        <Money v-model="form.valor_fat_extra_interior" v-bind="money" />
        <label>Hora extra faturamento FHC</label>
        <Money v-model="form.valor_fat_extra_interior_diferenciado" v-bind="money" required />
      </div>
      <div class="bk column grid-2-g grid-3-m grid-6-s">
        <label>Faturamento do job capital</label>
        <Money v-model="form.valor_fat_job_capital" />
        <label>Faturamento do job capital FHC</label>
        <Money v-model="form.valor_fat_job_capital_diferenciado" v-bind="money" />
      </div>
      <div class="bk column grid-2-g grid-3-m grid-6-s">
        <label>Hora Extra Faturamento Capital</label>
        <Money v-model="form.valor_fat_extra_capital" v-bind="money" />
        <label>Hora extra faturamento capital FHC</label>
        <Money v-model="form.valor_fat_extra_capital_diferenciado" v-bind="money" />
      </div>
    </div>
    <div class="legenda" v-if="!afat"><b>(FHC)</b> Fora do horário comercial</div>

    <SelectMaterial v-if="form.id" :id_tipo_servico="form.id" />

    <div v-if="form.nome_criado_por" class="info row wrap column-s justify-around">
      <div class="text-center grid-5">
        <label>Criado por</label>
        <div>{{ form.nome_criado_por }} em {{ form.criado_em | date }}</div>
      </div>
      <div class="text-center grid-5" v-if="form.nome_alterado_por">
        <label>Alterado por</label>
        <div>{{ form.nome_alterado_por }} em {{ form.alterado_em | date }}</div>
      </div>
    </div>

    <div class="controls row justify-center">
      <br /><br />
      <Button type="submit" :loader="loader" layout="green-go"><i class="fa fa-edit" />{{ form.update ? "ATUALIZAR" :
        "ADICIONAR" }}</Button>&nbsp;&nbsp;&nbsp;
      <Button v-if="form.update && form.status=='ativo'" type="button" @click="del" :loader="loader" layout="red-go"><i class="fa fa-trash" />
        DESATIVAR</Button>
       <!--  <Button v-if="form.update && form.status=='inativo'" type="button" @click="del" :loader="loader" layout="green-go"><i class="fa fa-trash" />
        ATIVAR</Button> -->
    </div>
  </form>
</template>

<script>
import { mapActions } from "vuex";
import Button from "@/components/Button.vue";
import { Money } from "v-money";
import Turnkey from "@/components/Turnkey.vue";
import SelectFilter from "@/components/select/SelectFilter";
import SelectMaterial from "@/views/admin/components/SelectMaterial";

export default {
  name: "ServiceTypeForm",
  components: { Button, Money, Turnkey, SelectFilter, SelectMaterial },
  props: { form: Object },
  data() {
    return {
      negocios: [],
      acusto: true,
      afat: true,
      custo: { job: "", hora: "", j: "", h: "" },
      fat: { job: "", hora: "", j: "", h: "" },
      turnkey: {
        show: true,
        on: false,
        toggle: () => {
          this.turnkey.on = !this.turnkey.on;
          this.form.interno = this.turnkey.on;
        },
      },
      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false,
      },
      loader: false,
      basisCost: [],
      especialities: [],
      guidelines: [],
      proporcao_custo_orcado: 0
    };
  },
  methods: {
    ...mapActions("admin", ["NEGOCIOS", "BASISCOST_LIST", "ESPECIALITY_LIST", "GUIDELINES_LIST", "COST_PROPORTION"]),
    validaTipo() {
      if (this.form.tipo_deslocamento == 'zero') (this.form.valor_deslocamento_fixo = null, this.form.limite_km_deslocamento_variavel = null, this.form.valor_deslocamento_variavel = null)
      if (this.form.tipo_deslocamento == 'variavel') (this.form.valor_deslocamento_fixo = null, this.form.valor_deslocamento_variavel = 0, this.form.limite_km_deslocamento_variavel = 0)
      if (this.form.tipo_deslocamento == 'fixo') (this.form.valor_deslocamento_fixo = 0, this.form.limite_km_deslocamento_variavel = null, this.form.valor_deslocamento_variavel = null)
      this.form = {...this.form}
    },
    async send() {
      this.loader = true;
      if (this.form && this.form.send && this.form.send != 'undefined' && this.form.send != undefined) {

        if (this.acusto) {

          this.form.valor_orcado_job_interior = this.custo.job
          this.form.valor_orcado_job_interior_diferenciado = this.form.valor_orcado_job_interior
          this.calc('valor_job_interior_diferenciado', this.form.valor_orcado_job_interior)
          this.form.valor_orcado_job_capital = this.form.valor_orcado_job_interior
          this.calc('valor_job_capital', this.form.valor_orcado_job_interior)
          this.form.valor_orcado_job_capital_diferenciado = this.form.valor_orcado_job_interior
          this.calc('valor_job_capital_diferenciado', this.form.valor_orcado_job_interior)
          this.form.valor_orcado_extra_interior = this.custo.hora
          this.form.valor_orcado_extra_interior_diferenciado = this.form.valor_orcado_extra_interior
          this.calc('valor_extra_interior_diferenciado', this.form.valor_orcado_extra_interior)
          this.form.valor_orcado_extra_capital = this.form.valor_orcado_extra_interior
          this.calc('valor_extra_capital', this.form.valor_orcado_extra_interior)
          this.form.valor_orcado_extra_capital_diferenciado = this.form.valor_orcado_extra_interior
          this.calc('valor_extra_capital_diferenciado', this.form.valor_orcado_extra_interior)

        }
        if (this.afat) {

          this.form.valor_fat_job_interior = this.fat.job
          this.form.valor_fat_extra_interior = this.fat.hora
          this.form.valor_fat_job_interior_diferenciado = this.form.valor_fat_job_interior
          this.form.valor_fat_job_capital = this.form.valor_fat_job_interior
          this.form.valor_fat_job_capital_diferenciado = this.form.valor_fat_job_interior
          this.form.valor_fat_extra_interior_diferenciado = this.form.valor_fat_extra_interior
          this.form.valor_fat_extra_capital = this.form.valor_fat_extra_interior
          this.form.valor_fat_extra_capital_diferenciado = this.form.valor_fat_extra_interior
        }

        let data = { ...this.form }
        if (data.deducao_fat_job_improdutivo == 0) delete data.deducao_fat_job_improdutivo
        else data.deducao_fat_job_improdutivo /= 100
        if (data.deducao_job_improdutivo == 0) delete data.deducao_job_improdutivo
        else data.deducao_job_improdutivo /= 100
        await this.form.send(data)
        this.loader = false
      }
    },
    calc(a, value) {
      let v = parseFloat(parseFloat(value.toString().replace('.', '').replace(',', '.')) * (this.proporcao_custo_orcado / 100)).toFixed(2);
      this.form.change(a, v);
      this.form[a] = v;
      this.$forceUpdate()
    },
    del() {
      this.loader = true;
      this.form
        .del(this.form)
        .then(() => (this.loader = false))
        .catch(() => (this.loader = false));
    },
  },
  beforeMount() {
    this.form.deducao_fat_job_improdutivo *= 100
    this.form.deducao_job_improdutivo *= 100
    if (
      this.form.valor_orcado_job_interior != (this.form.valor_orcado_job_interior_diferenciado || this.form.valor_orcado_job_capital || this.form.valor_orcado_job_capital_diferenciado) ||
      this.form.valor_orcado_extra_interior != (this.form.valor_orcado_extra_interior_diferenciado || this.form.valor_orcado_extra_capital || this.form.valor_orcado_extra_capital_diferenciado)
    ) this.acusto = false
    else this.custo = {
      job: this.form.valor_orcado_job_interior,
      hora: this.form.valor_orcado_extra_interior,
      j: this.form.valor_job_interior,
      h: this.form.valor_extra_interior
    }

    if (this.form.valor_fat_job_interior != (this.form.valor_fat_job_interior_diferenciado || this.form.valor_fat_job_capital || this.form.valor_fat_job_capital_diferenciado)
      || this.form.valor_fat_extra_interior != (this.form.valor_fat_extra_interior_diferenciado || this.form.valor_fat_extra_capital || this.form.valor_fat_extra_capital_diferenciado)) this.afat = false
    else this.fat = {
      job: this.form.valor_fat_job_interior,
      hora: this.form.valor_fat_extra_interior
    }
  },
  mounted() {
    this.turnkey.on = this.form.interno;
    this.NEGOCIOS().then((r) => { if (r.data) this.negocios = r.data })
    this.COST_PROPORTION().then(({ data }) => (this.proporcao_custo_orcado = data.proporcao_custo_orcado * 100));
    this.ESPECIALITY_LIST().then(({ data }) => (this.especialities = data || []));
    this.BASISCOST_LIST().then(({ data }) => (this.basisCost = data || []));
    this.GUIDELINES_LIST({ status: "ativo" }).then(({ data }) => this.guidelines = data || []);
  },
};
</script>

<style lang="sass" scoped>
@use "@/assets/scss/vars.scss" as *
.serviceTypeForm
  @include form
  .turnkey
    height: 48px
  .section .turnkey
    margin-top: 5px   
  .section 
    span
      font-size: 10px
      margin-top: 3px
      color: $blue-1
      font-weight: bold
  .legenda
    text-align: center
    font-size: 12px
    color: $purple
</style>
